function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Xl/Portal-Asociado-Menu",
  transform: "translate(-247.000000, -883.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "component/Xs/Menu/Portal/Nl+sociales-Copy-4",
  transform: "translate(47.000000, 883.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-icon/60X60/Gmail-Naranja",
  transform: "translate(200.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-3",
  fill: "#D0021B",
  cx: 25,
  cy: 25,
  r: 25
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.8060692,32.9187567 C28.4126091,33.1558886 20.8530317,33.1558886 17.4633102,32.9187567 C13.788204,32.6651398 13.3607502,30.8327575 13.3333333,24.8816361 C13.3607502,18.9216382 13.7931889,17.1006686 17.4633102,16.8445155 C20.8517854,16.6073837 28.4138553,16.6073837 31.8060692,16.8445155 C35.4824216,17.0981325 35.9086292,18.9305148 35.9372923,24.8816361 C35.9098754,30.8441702 35.4786829,32.6626036 31.8060692,32.9187567 Z M21.4063539,21.0342673 L29.3447825,24.8752957 L21.4063539,28.729005 L21.4063539,21.0342673 Z",
  id: "iconmonstr-youtube-9-path",
  fill: "#FFFFFF"
})))));

function SvgLogoYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "491D9AC5-9449-4719-9482-ACF41526B4B8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutube);
export default __webpack_public_path__ + "static/media/logo-youtube.0d1f3483.svg";
export { ForwardRef as ReactComponent };